import { render, staticRenderFns } from "./ListSlatItems.vue?vue&type=template&id=80419db0&"
import script from "./ListSlatItems.vue?vue&type=script&lang=js&"
export * from "./ListSlatItems.vue?vue&type=script&lang=js&"
import style0 from "./ListSlatItems.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports